import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import LogInModal from '../components/internal/log-in-modal';

/**
 * @description Renders hamburger menu content.
 */
class HamburgerContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: this.props.isOpen ? this.props.isOpen : false,
            isModalOpen: false
        }
    }

    componentDidMount () {
        document.addEventListener('click', this.handleClick);
        const appHeight = () => document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
        window.addEventListener('resize', appHeight)
        appHeight()
    }

    componentWillUnmount = () => {
        document.removeEventListener('click', this.handleClick);
    }

    handleClick = event => {
        if(event.target?.href === 'javascript:;') {
            return
        }
        
        if ((!event.target.closest('header') || event.target.tagName === 'A') && this.props.isOpen) {
            this.props.close();
        }

        if(event.target.classList.contains('logo-nav') && this.props.isOpen){
            this.props.close();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen !== this.state.isOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    }

    handleSearchKeyDown (event) {
        if (event.key === 'Enter') {
            this.props.close();
            navigate(`/search/?q=${event.target.value}`);
        }
    }

    toggleModal () {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    }

    render() {
        const styles = {
            container: {
                position: 'fixed',
                top: 0,
                left: 0,
                bottom: 0,
                overflowY: 'scroll',
                overflowX: 'hidden',
                height: this.state.isOpen ? 'var(--app-height)' : 0,
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                opacity: 1,
                color: '#fafafa',
                zIndex: 2,
                marginBottom: '50px'
            },
            menuList: {
                paddingTop: '6.2rem',
            }
        };

        return (
            <div style={styles.container}>
                {
                    this.state.isOpen ?
                        <div style={styles.menuList} className="mobile-bg">
                            <div className="container">
                                <input
                                    type="text"
                                    onKeyDown={event => this.handleSearchKeyDown(event)}
                                    className="form-control"
                                    aria-describedby="search"
                                    placeholder='Search' />
                                <div className="menu-items main-nav-mobile clearfix">
                                    {this.props.navigationMain}
                                </div>
                                <div className="menu-items sec-nav-mobile clearfix">
                                    {this.props.navigation}
                                </div>
                                <div className='signin-and-create-container'>
                                    <button className="btn-log-in btn btn-sm" onClick={() => this.toggleModal()}>Sign in</button>
                                    <a className="btn-create btn btn-sm" href="https://apply.commonapp.org/createaccount" target="_blank" rel="noopener noreferrer">Create an Account</a>
                                </div>
                            </div>
                        </div> : null
                }
                <LogInModal show={this.state.isModalOpen} handleClose={() => this.toggleModal()} />
            </div>
        );
    }
}

HamburgerContent.propTypes = {
    isOpen: PropTypes.bool,
    navigation: PropTypes.array.isRequired
};

export default HamburgerContent;
